module.exports = __webpack_public_path__ + "static/rock1-a960477e1809818ac559cf4a56893611.svg";